import { useQuery } from '@tanstack/react-query'

import type { AirportSuggestionMode, GetDefaultAirportSuggestionsResponse } from '../../types/index.js'

import { apiClient } from '../../lib/client.js'
import { airportKeys } from './keys.js'

const ONE_HOUR_IN_MS = 60 * 60 * 1000

/**
 * Liste curée de villes affichée dans l'autocomplete quand la recherche est vide.
 * Quasi statique : on la garde longtemps en cache pour qu'elle soit déjà présente
 * au premier clic sur le champ.
 */
export const useGetDefaultAirportSuggestionsQuery = ({ mode }: { mode: AirportSuggestionMode }) =>
  useQuery({
    gcTime: ONE_HOUR_IN_MS,
    queryFn: async () => {
      const response = await apiClient.client.get<GetDefaultAirportSuggestionsResponse>(
        `/airport/default-suggestions/${mode}`
      )
      return response.data
    },
    queryKey: airportKeys.defaultSuggestions(mode),
    staleTime: ONE_HOUR_IN_MS,
  })
